import { AlmeMessageHandlerUtils } from './AlmeMessageHandlerUtils';
import { useEffect, useState } from 'react';
import { createAlmeApi, createApiSetting, createLiveChatNotificationApi } from '../AlmeApi';
import { AlmeApiUtils } from '../AlmeApiUtils';
import { getLogger } from '../utils/DebugUtils';
function handleMessage(message, almeState, setAlmeState, appConfig, setDelayPostMessageHandle, ivaSetChatStatus, setAlmeAppConfig) {
    const apiSettings = createApiSetting(appConfig.main.apiHostName);
    const logger = getLogger(appConfig.UiLogLevel);
    const liveChatNotificationApi = createLiveChatNotificationApi(apiSettings, logger);
    const almeApi = createAlmeApi(apiSettings, logger);
    const messageHandlerUtils = new AlmeMessageHandlerUtils(almeState, setAlmeState, appConfig, new AlmeApiUtils(almeState, setAlmeState, appConfig, almeApi, liveChatNotificationApi), setDelayPostMessageHandle, ivaSetChatStatus, setAlmeAppConfig);
    messageHandlerUtils.HandleMessage(message);
}
export default function useDelayPostMessageHandler(state, setAlmeState, appConfig, ivaSetChatStatus, setAlmeAppConfig) {
    const [message, setMessage] = useState(null);
    useEffect(() => {
        if (message && state.historyLoaded) {
            handleMessage(message, state, setAlmeState, appConfig, setMessage, ivaSetChatStatus, setAlmeAppConfig);
            setMessage(null);
        }
    }, [appConfig, message, setAlmeState, state, ivaSetChatStatus, setAlmeAppConfig]);
    return setMessage;
}
